import type { MessageKey } from '../en';

export const id: Partial<Record<MessageKey, string>> = {
  "defaults.accuracy.desc": "Akurasi untuk titik riwayat baru",
  "defaults.accuracy.title": "Akurasi GPS bawaan",
  "defaults.actual.desc": "Dipakai untuk mencari tempat selama simulasi",
  "defaults.actual.empty": "Belum tersimpan",
  "defaults.actual.emptyHint": "Izinkan lokasi dan buka aplikasi tanpa simulasi untuk merekamnya.",
  "defaults.actual.pending": "Ponsel menyimpan lokasi ini. Sinkronisasi belum terhubung.",
  "defaults.actual.refresh": "Perbarui sekarang",
  "defaults.actual.title": "Lokasi nyata kamu",
  "defaults.browserChip": "Browser ini",
  "defaults.close": "Tutup",
  "defaults.color.desc": "Warna garis rute baru",
  "defaults.color.group": "Warna rute",
  "defaults.color.title": "Warna rute",
  "defaults.degrees": "{n}°",
  "defaults.format.dayMonthYear": "Tanggal, tahun · 12 jam",
  "defaults.format.dayShort": "Hari dan tanggal · 12 jam",
  "defaults.format.eu": "Tanggal UE · 24 jam",
  "defaults.format.fullDay": "Tanggal lengkap · 12 jam",
  "defaults.format.iso": "Tanggal ISO · 24 jam",
  "defaults.format.monthFirst": "Bulan dulu · 24 jam",
  "defaults.format.shortDayYear": "Hari, tanggal, tahun · 24 jam",
  "defaults.format.timeFirst": "Waktu dulu · 24 jam",
  "defaults.format.us": "Tanggal AS · 12 jam",
  "defaults.format.withSeconds": "Dengan detik · 12 jam",
  "defaults.itinAccuracy.desc": "Akurasi GPS segmen baru",
  "defaults.itinAccuracy.title": "Akurasi",
  "defaults.itinerary.desc": "Bawaan untuk segmen baru",
  "defaults.itinerary.title": "Rute",
  "defaults.joyAccuracy.desc": "Akurasi GPS awal saat membuat sesi joystick",
  "defaults.joyAccuracy.title": "Akurasi GPS bawaan",
  "defaults.joyName.desc": "Nama bawaan sesi joystick baru",
  "defaults.joyName.dialogTitle": "Pilih format nama sesi",
  "defaults.joyName.title": "Format tanggal",
  "defaults.joySpeed.desc": "Kecepatan awal saat membuat sesi joystick",
  "defaults.joySpeed.title": "Kecepatan bawaan",
  "defaults.joyUnit.desc": "Menampilkan dan mengatur kecepatan joystick dalam km/jam atau mph",
  "defaults.joystick.desc": "Bawaan untuk sesi joystick",
  "defaults.joystick.title": "Joystick",
  "defaults.kilometers": "{n} km",
  "defaults.map.desc": "Cara peta baru terbuka",
  "defaults.map.title": "Google Map",
  "defaults.mapTheme.desc": "Tampilan layar peta baru",
  "defaults.mapTheme.group": "Tema peta",
  "defaults.mapTheme.title": "Tema peta",
  "defaults.marker.car": "Mobil",
  "defaults.marker.desc": "Dipakai saat membuat sesi joystick. Bisa diubah per sesi.",
  "defaults.marker.group": "Penanda bawaan",
  "defaults.marker.maps": "Maps",
  "defaults.marker.title": "Penanda bawaan",
  "defaults.marker.waze": "Waze",
  "defaults.meters": "{n} m",
  "defaults.nameFormat.desc": "Nama bawaan titik tetap",
  "defaults.nameFormat.dialogSubtitle": "Pratinjau memakai tanggal hari ini. Pilih format ringkas untuk titik baru.",
  "defaults.nameFormat.dialogTitle": "Pilih format nama titik",
  "defaults.nameFormat.group": "Format tanggal",
  "defaults.nameFormat.title": "Format tanggal",
  "defaults.overlay.itinerary.desc": "Pemutar mengambang saat simulasi rute berlanjut di latar",
  "defaults.overlay.itinerary.title": "Rute otomatis",
  "defaults.overlay.joystick.desc": "Joystick mengambang saat sesi berlanjut di latar",
  "defaults.overlay.joystick.title": "Joystick",
  "defaults.overlay.playlist.desc": "Pemutar mengambang saat simulasi daftar berlanjut di latar",
  "defaults.overlay.playlist.title": "Daftar",
  "defaults.overlay.stationary.desc": "Pemutar mengambang saat simulasi tetap berlanjut di latar",
  "defaults.overlay.stationary.title": "Titik tetap",
  "defaults.plAccuracy.desc": "Akurasi GPS yang diterapkan ke setiap pin daftar",
  "defaults.plAccuracy.title": "Akurasi per item",
  "defaults.player.desc": "Kontrol pemutar overlay dan simulasi",
  "defaults.player.title": "Pemutar",
  "defaults.playlist.desc": "Bawaan untuk pin daftar baru",
  "defaults.playlist.title": "Daftar",
  "defaults.polyline.desc": "Warna bawaan rute yang digambar selama sesi joystick.",
  "defaults.polyline.group": "Warna polyline",
  "defaults.polyline.title": "Warna polyline bawaan",
  "defaults.range.accuracyMax": "300 m",
  "defaults.range.accuracyMin": "0 m",
  "defaults.range.itinAccuracyMax": "100",
  "defaults.range.itinAccuracyMin": "1",
  "defaults.range.joyAccuracyMax": "100 m",
  "defaults.range.joyAccuracyMin": "1 m",
  "defaults.range.plAccuracyMax": "500 m",
  "defaults.range.plAccuracyMin": "0 m",
  "defaults.range.searchMax": "50 km",
  "defaults.range.searchMin": "3 km",
  "defaults.range.tiltMax": "65°",
  "defaults.range.tiltMin": "0°",
  "defaults.range.timeMax": "600 dtk",
  "defaults.range.timeMin": "0 dtk",
  "defaults.range.zoomMax": "20",
  "defaults.range.zoomMin": "10",
  "defaults.reset": "Atur ulang",
  "defaults.search.itinerary": "Hasil di dekat pusat peta diutamakan",
  "defaults.search.playlist": "Hasil di dekat pusat peta diutamakan",
  "defaults.search.stationary": "Hasil di dekat pin kamu diutamakan",
  "defaults.search.title": "Radius pencarian",
  "defaults.seconds": "{n} dtk",
  "defaults.section.appearance": "Tampilan",
  "defaults.section.camera": "Kamera",
  "defaults.section.history": "Riwayat",
  "defaults.section.location": "Konteks lokasi",
  "defaults.section.map": "Peta",
  "defaults.section.motion": "Gerakan",
  "defaults.section.overlay": "Pemutar overlay",
  "defaults.section.playlist": "Daftar",
  "defaults.section.search": "Pencarian",
  "defaults.section.style": "Gaya",
  "defaults.section.view": "Peta",
  "defaults.sectionDefaults": "Bawaan aplikasi",
  "defaults.sectionDefaultsDesc": "Atur bawaan agar pengalaman lebih cepat dan lancar",
  "defaults.sectionPlayer": "Pemutar",
  "defaults.sectionPlayerDesc": "Pengaturan overlay dan pemutaran",
  "defaults.speed.desc": "Kecepatan pemutaran segmen baru",
  "defaults.speed.title": "Kecepatan bawaan",
  "defaults.speedValue": "{n} {unit}",
  "defaults.stationary.desc": "Bawaan untuk titik peta baru",
  "defaults.stationary.title": "Titik tetap",
  "defaults.summary.playerAll": "Semua overlay aktif",
  "defaults.summary.playerOff": "Overlay nonaktif",
  "defaults.summary.playerSome": "{on} dari 4 aktif",
  "defaults.summary.zoom": "zoom {n}",
  "defaults.syncNote": "Disimpan di browser ini untuk sekarang. Aplikasi ponsel akan memakai nilai ini setelah sinkronisasi terhubung.",
  "defaults.theme.night": "Malam",
  "defaults.theme.nightDesc": "Warna peta gelap untuk cahaya redup dan sesi malam.",
  "defaults.theme.retro": "Retro",
  "defaults.theme.retroDesc": "Nada hangat klasik, terasa seperti peta lama.",
  "defaults.theme.silver": "Perak",
  "defaults.theme.silverDesc": "Abu-abu terang, nyaman di siang hari.",
  "defaults.theme.standard": "Standar",
  "defaults.theme.standardDesc": "Warna Google Maps klasik, dengan hijau dan biru yang familiar.",
  "defaults.tilt.desc": "Sudut kamera di layar peta",
  "defaults.tilt.title": "Kemiringan kamera bawaan",
  "defaults.time.desc": "Jeda sebelum pindah ke pin berikutnya",
  "defaults.time.title": "Waktu per item",
  "defaults.tray.group": "Tinggi baki",
  "defaults.tray.large": "Besar",
  "defaults.tray.medium": "Sedang",
  "defaults.tray.playlistDesc": "Panel daftar yang terlihat di peta",
  "defaults.tray.small": "Kecil",
  "defaults.tray.stationaryDesc": "Ukuran panel yang terlihat di peta",
  "defaults.tray.title": "Tinggi baki",
  "defaults.unit.group": "Satuan kecepatan",
  "defaults.unit.itineraryDesc": "Menampilkan kecepatan sebagai km/jam atau mph di modul rute",
  "defaults.unit.kmh": "km/jam",
  "defaults.unit.mph": "mph",
  "defaults.unit.title": "Satuan kecepatan",
  "defaults.view.grid": "Kisi",
  "defaults.view.group": "Tampilan",
  "defaults.view.historyDesc": "Cara titik tersimpan ditampilkan",
  "defaults.view.historyTitle": "Tampilan riwayat",
  "defaults.view.list": "Daftar",
  "defaults.view.playlistDesc": "Cara daftar tersimpan ditampilkan",
  "defaults.view.playlistTitle": "Tampilan daftar",
  "defaults.zoom.desc": "Zoom awal peta baru",
  "defaults.zoom.title": "Tingkat zoom bawaan",
  "language.defaultBadge": "Bawaan",
  "language.empty": "Tidak ada bahasa yang cocok dengan pencarian ini.",
  "language.lead": "Inggris (Amerika Serikat) adalah bahasa bawaan. Pilihan kamu tersimpan di browser ini.",
  "language.listLabel": "Bahasa",
  "language.preview": "Lokasi simulasi, daftar, dan rute.",
  "language.previewLabel": "Pratinjau",
  "language.searchLabel": "Cari bahasa",
  "language.searchPlaceholder": "Cari bahasa",
  "nav.account": "Akun",
  "nav.account.desc": "Profil, Premium, dan masuk.",
  "nav.analytics": "Analitik",
  "nav.analytics.desc": "Pahami aktivitas MockLoc, pemakaian jaringan, dan status sinkronisasi.",
  "nav.articles": "Artikel",
  "nav.articles.desc": "Panduan penyiapan, pemutaran, dan sinkronisasi.",
  "nav.backup": "Cadangan dan sinkronisasi",
  "nav.backup.desc": "Status cadangan awan dan sinkronisasi.",
  "nav.coins": "Mock Coins",
  "nav.coins.desc": "Rincian lengkap pemakaian koin menurut modul dan aktivitas.",
  "nav.dashboard": "Dasbor",
  "nav.dashboard.desc": "Ringkasan lokasi, daftar, rute, dan aktivitas akun.",
  "nav.devices": "Kelola perangkat",
  "nav.devices.desc": "Lihat perangkat yang masuk ke akun MockLoc kamu.",
  "nav.help": "Bantuan dan dukungan",
  "nav.help.desc": "Ikuti percakapan dan minta bantuan tim MockLoc.",
  "nav.history": "Riwayat lokasi",
  "nav.history.desc": "Tempat yang disimulasikan akun ini.",
  "nav.itinerary": "Rute",
  "nav.itinerary.desc": "Buat, ubah, dan kelola rute tersimpan.",
  "nav.joystick": "Sesi joystick",
  "nav.joystick.desc": "Rute pemutaran, statistik, dan sesi joystick tersimpan.",
  "nav.notifications": "Notifikasi",
  "nav.notifications.desc": "Pemberitahuan sinkronisasi, cadangan, dan produk.",
  "nav.playlist": "Daftar",
  "nav.playlist.desc": "Kumpulan lokasi simulasi yang berurutan.",
  "nav.settings": "Pengaturan",
  "nav.settings.desc": "Tema, bahasa, dan bawaan aplikasi seluler.",
  "nav.stationary": "Titik tetap",
  "nav.stationary.desc": "Lokasi simulasi tetap yang tersimpan di akun ini.",
  "nav.whatsNew": "Yang baru di aplikasi",
  "nav.whatsNew.desc": "Pembaruan, perbaikan, dan peningkatan baru di MockLoc.",
  "settings.back": "Pengaturan",
  "settings.backDefaults": "Bawaan aplikasi",
  "settings.defaults.shellDesc": "Nilai yang dipakai aplikasi ponsel untuk peta, titik, rute, dan pemutaran.",
  "settings.defaults.shellTitle": "Bawaan aplikasi",
  "settings.home.defaults.desc": "Bawaan peta, titik, daftar, rute, joystick, dan pemutar dari aplikasi ponsel.",
  "settings.home.defaults.title": "Bawaan aplikasi seluler",
  "settings.home.language.desc": "Pilih bahasa menu, judul halaman, dan pengaturan.",
  "settings.home.language.title": "Pengaturan bahasa",
  "settings.home.theme.desc": "Ukuran teks, warna, terang atau gelap, dan font untuk browser ini.",
  "settings.home.theme.title": "Pengaturan tema",
  "settings.language.shellDesc": "Pilih bahasa situs ini.",
  "settings.language.shellTitle": "Bahasa",
  "settings.theme.shellDesc": "Ukuran teks, warna, terang atau gelap, dan font untuk browser ini.",
  "settings.theme.shellTitle": "Tema",
  "shell.account": "Akun",
  "shell.accountMenu": "Menu akun",
  "shell.accountMenuNamed": "Menu akun, {name}",
  "shell.closeMenu": "Tutup menu",
  "shell.collapseSidebar": "Ciutkan bilah sisi",
  "shell.dashboardSubtitle": "Kelola lokasi simulasi, daftar, rute, dan lainnya di satu tempat.",
  "shell.devicesLimit": "Pakai di maksimal 3 perangkat",
  "shell.expandSidebar": "Perluas bilah sisi",
  "shell.goPremium": "Berlangganan Premium",
  "shell.logOut": "Keluar",
  "shell.mainNav": "Navigasi utama",
  "shell.noMatches": "Tidak ada yang cocok",
  "shell.notifications": "Notifikasi",
  "shell.notificationsUnread": "Notifikasi, {count} belum dibaca",
  "shell.openMenu": "Buka menu",
  "shell.pages": "Halaman",
  "shell.recent": "Terbaru",
  "shell.searchLabel": "Cari lokasi, daftar, rute, artikel",
  "shell.searchPlaceholder": "Cari lokasi, daftar, rute, artikel...",
  "shell.searchResults": "Hasil pencarian",
  "shell.tagline": "Lokasi simulasi, dengan cara sederhana",
  "shell.themeDarkTitle": "Tema gelap",
  "shell.themeLightTitle": "Tema terang",
  "shell.themeToDark": "Ganti ke tema gelap",
  "shell.themeToLight": "Ganti ke tema terang",
  "shell.there": "kamu",
  "shell.unlimitedCoins": "Koin tanpa batas",
  "shell.unlimitedEverything": "Semua tanpa batas",
  "shell.upgradeNow": "Tingkatkan sekarang",
  "shell.viewAllNotifications": "Lihat semua notifikasi",
  "shell.welcome": "Selamat datang kembali, {name}!",
  "theme.builtin": "Bawaan",
  "theme.changesLabel": "Yang berubah.",
  "theme.color.accent.changes": "Emas merek dan latar emas pucat, termasuk detail kecil ilustrasi.",
  "theme.color.accent.title": "Aksen",
  "theme.color.accent.where": "Sorotan emas pada masuk, artikel, dan lencana.",
  "theme.color.danger.changes": "Teks kesalahan merah dan tindakan merusak.",
  "theme.color.danger.title": "Bahaya",
  "theme.color.danger.where": "Kesalahan, penghapusan, dan titik belum dibaca.",
  "theme.color.info.changes": "Biru yang dipakai untuk info di tema terang dan gelap.",
  "theme.color.info.title": "Info",
  "theme.color.info.where": "Status biru, tautan info, dan tanda info.",
  "theme.color.lead": "Warna bawaan tetap berbeda di tema terang dan gelap sampai kamu memilih satu. Pilihan kamu berlaku di kedua tema. Warna yang tersimpan pada titik, daftar, atau rute tetap tersimpan.",
  "theme.color.primary.changes": "Ungu solid, teks ungu muda, dan latar ungu lembut.",
  "theme.color.primary.title": "Utama",
  "theme.color.primary.where": "Tombol, item menu aktif, tautan, dan ungu merek.",
  "theme.color.success.changes": "Teks status hijau dan tanda berhasil.",
  "theme.color.success.title": "Berhasil",
  "theme.color.success.where": "Tersinkron, selesai, dan status positif.",
  "theme.color.title": "Warna",
  "theme.color.warning.changes": "Peringatan amber dan emas yang dipakai pada koin.",
  "theme.color.warning.title": "Peringatan",
  "theme.color.warning.where": "Peringatan, tanda koin, dan sorotan Premium.",
  "theme.colorAria": "Warna {title}",
  "theme.custom": "Kustom",
  "theme.face.arialBold": "Arial Bold",
  "theme.face.arialRegular": "Arial Regular",
  "theme.face.arialSynth": "Disintesis dari Arial",
  "theme.face.gsBold": "Google Sans Bold",
  "theme.face.gsRegular": "Google Sans Regular",
  "theme.face.helveticaOther": "Helvetica atau disintesis",
  "theme.face.helveticaRegular": "Helvetica Regular",
  "theme.face.inter": "Inter {weight}",
  "theme.font.arial.note": "Regular dan Bold adalah font terpasang. Ketebalan lain disintesis.",
  "theme.font.google-sans.note": "Berkas Regular mencakup 400 dan 500. Berkas Bold mencakup 600 sampai 900.",
  "theme.font.group": "Font",
  "theme.font.helvetica.note": "Memakai Helvetica di perangkat ini, lalu Helvetica Neue, lalu Arial.",
  "theme.font.inter.note": "Font yang dipakai situs hari ini. Regular sampai Black sudah dimuat.",
  "theme.font.lead": "Satu keluarga dipakai di seluruh situs. Judul pemasaran kembali ke Plus Jakarta Sans saat Inter dipilih. Ketebalan di bawah adalah yang sudah dipakai antarmuka.",
  "theme.font.sample": "Lokasi simulasi, dengan cara sederhana",
  "theme.font.title": "Font",
  "theme.hexAria": "Heksa {title}",
  "theme.lead": "Pilih ukuran teks, warna, terang atau gelap, dan font browser ini. 100% sama dengan layar hari ini. Contoh di sini, dan seluruh situs, berubah bersama.",
  "theme.manager": "Pengelola tema",
  "theme.mode.dark": "Gelap",
  "theme.mode.darkHint": "Permukaan gelap dan teks terang.",
  "theme.mode.group": "Tema",
  "theme.mode.lead": "Pilihan terang atau gelap yang sama dengan tombol di bilah atas.",
  "theme.mode.light": "Terang",
  "theme.mode.lightHint": "Permukaan terang dan teks gelap.",
  "theme.mode.title": "Tema",
  "theme.previewBody": "Lokasi tersimpan di akun ini.",
  "theme.previewBold": "Daftar siap",
  "theme.previewHelp": "Kumpulan lokasi simulasi yang berurutan.",
  "theme.previewKicker": "Pratinjau langsung",
  "theme.previewTitle": "Lokasi simulasi",
  "theme.reset": "Atur ulang",
  "theme.resetAll": "Atur ulang semua",
  "theme.resetColors": "Atur ulang warna",
  "theme.resetFont": "Atur ulang font",
  "theme.resetText": "Atur ulang teks",
  "theme.sizeAria": "Ukuran {title}",
  "theme.text.bold.changes": "Teks 15 px sampai 18 px.",
  "theme.text.bold.sample": "Berlangganan Premium",
  "theme.text.bold.title": "Tebal",
  "theme.text.bold.where": "Judul kartu, nama merek, judul bagian, dan tombol besar.",
  "theme.text.descriptive.changes": "Teks 12 px sampai 13 px.",
  "theme.text.descriptive.sample": "Kumpulan lokasi simulasi yang berurutan.",
  "theme.text.descriptive.title": "Deskriptif",
  "theme.text.descriptive.where": "Subjudul, teks bantuan, lencana, kaki halaman, dan baris sekunder.",
  "theme.text.header.changes": "Teks 20 px ke atas.",
  "theme.text.header.sample": "Titik tetap",
  "theme.text.header.title": "Judul",
  "theme.text.header.where": "Judul halaman, judul besar, judul keadaan kosong, dan angka besar seperti saldo koin.",
  "theme.text.lead": "Setiap peran punya ukuran bersama. Contoh menampilkan peran itu. Penggeser di halaman ini tetap berukuran tetap agar mudah dipakai.",
  "theme.text.normal.changes": "Teks 14 px.",
  "theme.text.normal.sample": "Lokasi tersimpan di akun ini.",
  "theme.text.normal.title": "Normal",
  "theme.text.normal.where": "Label navigasi, tombol biasa, judul daftar, dan ringkasan singkat.",
  "theme.text.other.changes": "Teks 9 px sampai 11 px. Tanda di bawah 9 px tetap.",
  "theme.text.other.sample": "Diperbarui 2 jam lalu",
  "theme.text.other.title": "Lainnya",
  "theme.text.other.where": "Label kecil, stempel waktu, label grafik, dan keterangan.",
  "theme.text.title": "Teks",
  "theme.weight.black": "Black",
  "theme.weight.bold": "Bold",
  "theme.weight.extrabold": "Extra bold",
  "theme.weight.medium": "Medium",
  "theme.weight.regular": "Regular",
  "theme.weight.sample": "Lokasi simulasi, daftar, dan rute",
  "theme.weight.semibold": "Semibold",
  "theme.whereLabel": "Dipakai di mana.",
};
